/**
 * EDI-SIG Frontend Configuration & Helper Utilities Module
 */
const API_BASE = '/api/v1';

function sanitize(str) {
  if (str === null || str === undefined) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function showToast(icon, title) {
  if (typeof Swal !== 'undefined') {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true
    });
    Toast.fire({ icon, title });
  }
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { API_BASE, sanitize, showToast };
}
